import React from "react";
import { Section, Overline, H1, Lead } from "@/components/ui-kit";
import BuyerForm from "@/components/forms/BuyerForm";
import EmailLink from "@/components/EmailLink";

export default function Buyers() {
  return (
    <>
      <Section className="pt-12 md:pt-20 pb-8 md:pb-10">
        <Overline>For Buyers</Overline>
        <H1 className="mt-5 max-w-4xl">Join the Brightside Capital buyer network.</H1>
        <Lead className="mt-7 max-w-3xl">
          Get notified about off-market and value-add opportunities that match your buy box across Sacramento, Roseville,
          Rocklin, Lincoln, and the broader Northern California market.
        </Lead>
        <p className="mt-5 text-sm text-neutral-400">Prefer email? Reach acquisitions at <EmailLink email="acquisitions@brightsidecapital.net" testId="buyers-acq-email" className="text-neutral-200" /></p>
      </Section>
      <Section className="pb-24 md:pb-32" id="buyer-form-section" dataTestId="buyer-form-section">
        <BuyerForm />
      </Section>

      <section className="border-t border-white/10 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-20 text-center">
          <h2 className="font-display text-2xl sm:text-3xl tracking-tight font-medium text-white max-w-3xl mx-auto">Build your buy box once. Match it to deal flow.</h2>
          <p className="text-neutral-400 mt-4 max-w-xl mx-auto">No spam. We only reach out when a property fits your criteria.</p>
          <a href="#buyer-form-section" className="btn-gold inline-block mt-8 px-7 py-4 font-semibold">Get access to potential off-market opportunities</a>
        </div>
      </section>
    </>
  );
}
